package fr.manyverse.app.domain.validation

import fr.manyverse.app.domain.error.ValidationError

/**
 * Validator for timer data.
 */
object TimerValidator {

    private const val MIN_DURATION_SECONDS = 1
    private const val MAX_DURATION_SECONDS = 28800

    /**
     * Validates that the duration is within acceptable range.
     */
    fun validateDuration(durationSeconds: Int): Result<Unit> {
        if (durationSeconds < MIN_DURATION_SECONDS) {
            return Result.failure(ValidationError("Timer duration must be at least 1 second"))
        }
        if (durationSeconds > MAX_DURATION_SECONDS) {
            return Result.failure(ValidationError("Timer duration cannot exceed 8 hours"))
        }
        return Result.success(Unit)
    }

    /**
     * Validates that at least one participant is selected.
     */
    fun validateParticipants(participants: List<String>): Result<Unit> {
        if (participants.isEmpty()) {
            return Result.failure(ValidationError("At least one participant must be selected"))
        }
        return Result.success(Unit)
    }

    /**
     * Validates timer for creation.
     */
    fun validateForCreation(durationSeconds: Int, participants: List<String>): Result<Unit> {
        validateDuration(durationSeconds).onFailure {
            return Result.failure(it)
        }
        validateParticipants(participants).onFailure {
            return Result.failure(it)
        }
        return Result.success(Unit)
    }
}
